import gql from 'graphql-tag'

import { ChildFieldsFragment, IChild } from 'main/gql/child'

export interface IFamily {
  id: number
  children: IChild[]
}

export const FamilyFieldsFragment = gql`
  fragment FamilyFields on Family {
    id
    children {
      ...ChildFields
    }
  }

  ${ChildFieldsFragment}
`
